import React from "react";
import { Flame, Shield, Droplets, Ambulance } from "lucide-react";
import { ICON_STROKE } from "../ui/icon";

const QUICK_LINKS = [
  {
    label: "Call 108",
    shortLabel: "108",
    subtitle: "One Tap",
    number: "108",
    icon: Ambulance,
    tint: "danger",
    emoji: "🚑",
  },
  {
    label: "Police",
    shortLabel: "Police",
    subtitle: "Nearby",
    number: "100",
    icon: Shield,
    tint: "blue",
    emoji: "🚓",
  },
  {
    label: "Fire",
    shortLabel: "Fire",
    subtitle: "Station",
    number: "101",
    icon: Flame,
    tint: "orange",
    emoji: "🔥",
  },
  {
    label: "Blood Bank",
    shortLabel: "Blood",
    subtitle: "Banks",
    number: "104",
    icon: Droplets,
    tint: "rose",
    emoji: "🩸",
  },
];

const NearbyQuickEmergencyBar = ({ onCall, variant = "inline" }) => {
  const isMobileBar = variant === "mobile-bar";

  return (
    <section
      className={`nearby-quick-section ${
        isMobileBar ? "nearby-quick-section--mobile-bar" : "nearby-quick-section--inline"
      }`}
      aria-label="Emergency Quick Access"
    >
      {!isMobileBar && <h2 className="nearby-quick-section__title">Emergency Quick Access</h2>}

      <div className={isMobileBar ? "nearby-quick-bar" : "nearby-quick-grid"}>
        {QUICK_LINKS.map((item) => {
          const Icon = item.icon;
          return (
            <button
              key={item.label}
              type="button"
              className={
                isMobileBar
                  ? `nearby-quick-bar__btn nearby-quick-bar__btn--${item.tint}`
                  : `nearby-quick-card nearby-quick-card--${item.tint}`
              }
              aria-label={`Call ${item.label}`}
              onClick={() => onCall({ name: item.label, number: item.number })}
            >
              <span className={isMobileBar ? "nearby-quick-bar__emoji" : "nearby-quick-card__emoji"} aria-hidden>
                {item.emoji}
              </span>
              {!isMobileBar && (
                <span className="nearby-quick-card__icon" aria-hidden>
                  <Icon size={18} strokeWidth={ICON_STROKE} />
                </span>
              )}
              <span className={isMobileBar ? "nearby-quick-bar__label" : "nearby-quick-card__title"}>
                {isMobileBar ? item.shortLabel : item.label}
              </span>
              {!isMobileBar && <span className="nearby-quick-card__subtitle">{item.subtitle}</span>}
            </button>
          );
        })}
      </div>
    </section>
  );
};

export default NearbyQuickEmergencyBar;
